import React, { useState, ReactNode } from 'react';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';

interface PersistentTooltipProps extends TooltipProps {
  title: ReactNode;
}

export const PersistentTooltip: React.FC<PersistentTooltipProps> = ({ title, children, ...rest }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleToggleTooltip = () => {
    setOpen(!open);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      handleTooltipClose();
    }
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <span onKeyDown={handleKeyDown}>
        <Tooltip
          title={title}
          open={open}
          onClose={handleTooltipClose}
          enterTouchDelay={0}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          PopperProps={{
            disablePortal: true,
          }}
          {...rest}
        >
          <span onClick={handleToggleTooltip} aria-describedby="persistent-tooltip">
            {children}
          </span>
        </Tooltip>
      </span>
    </ClickAwayListener>
  );
};

